const state = {
	app_id: null
};
const getters = {
	user: (state, getters, rootState, rootGetters) =>
		rootGetters["userModule/get"],
	intercomData: (state, getters, rootState, rootGetters) =>
		rootGetters["userModule/intercomData"]
};
const actions = {
	mounted({ getters, commit }, intercom: any) {
		if (intercom) {
			const { user, intercomData } = getters;
			if (intercom && intercomData && intercomData.app_id) {
				if (user) {
					commit("SET_APP_ID", intercomData.app_id);
					intercom.boot(intercomData);
				} else {
					intercom.boot();
				}
			}
		}
	},
	logout({ state }) {
		if ((window as any).Intercom) {
			(window as any).Intercom("shutdown");
			(window as any).Intercom("boot", {
				app_id: state.app_id
			});
		}
	},
	refresh({ getters }) {
		if ((window as any).Intercom) {
			const { intercomData } = getters;
			(window as any).Intercom("update", intercomData);
		}
	},
	message() {
		if ((window as any).Intercom) {
			(window as any).Intercom("showMessages");
		}
	}
};
const mutations = {
	SET_APP_ID: (state, app_id) => {
		state.app_id = app_id;
	}
};

export default { namespaced: true, state, getters, actions, mutations };
